<div>
  <h2>{{ "THEME" | translate }}</h2>
  <mat-slide-toggle [(ngModel)]="isDarkTheme" (change)="toggleTheme()">
    {{ "DARK_THEME" | translate }}
  </mat-slide-toggle>
</div>

<div
  class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-2"
  [class]="hidden ? 'mt-2' : 'mt-5'"
></div>

<div
  [class]="
    'max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] ' +
    (hidden ? 'mt-2' : 'mt-5')
  "
>
  <h2 class="mb-1!">{{ "EXTERNAL_RATINGS_PREFERENCE_TITLE" | translate }}</h2>
  <p class="italic mt-0 mb-2">
    {{ "EXTERNAL_RATINGS_PREFERENCE_TEXT" | translate }}
  </p>
  <mat-slide-toggle
    [(ngModel)]="showExternalRatings"
    (change)="toggleExternalRatings($event)"
  >
    {{ "SHOW_EXTERNAL_RATINGS" | translate }}
  </mat-slide-toggle>
</div>

<div
  class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-2"
  [class]="hidden ? 'mt-2' : 'mt-5'"
></div>

<div [class]="hidden ? 'mt-2' : 'mt-5'">
  <h2>{{ (hidden ? "LANGUAGE" : "LANGUAGE_AND_COUNTRY") | translate }}</h2>
  <div class="block mb-5">
    <mat-form-field
      class="preferences-field !block w-full max-w-[460px] h-[50px] !rounded-lg"
    >
      <mat-label>{{ "LANGUAGE" | translate }}</mat-label>
      <mat-select
        [value]="user.language"
        (selectionChange)="onLanguageChange($event)"
      >
        <mat-option value="en"> {{ "ENGLISH" | translate }}</mat-option>
        <mat-option value="fr"> {{ "FRENCH" | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  @if (!hidden) {
  <div class="block mt-3">
    <app-country-select
      class="block w-full max-w-[460px]"
      [value]="user.country ?? 'US'"
      [language]="user.language"
      [disabled]="isCountrySaving"
      (valueChange)="onCountryChange($event)"
    ></app-country-select>
  </div>
  }
</div>

<div
  class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-5"
></div>

<div
  [class]="'block max-w-[460px] sm:max-w-[640px] ' + (hidden ? 'mt-2' : 'mt-5')"
>
  <h2 class="mb-1!">{{ "CONSUMED_TYPES_TITLE" | translate }}</h2>
  <p class="italic mt-0 mb-3">{{ "CONSUMED_TYPES_SUBTITLE" | translate }}</p>
  <app-media-types-grid
    class="grid-cols-4 gap-2 sm:gap-3"
    origin="preferences"
    [selected]="consumedTypes"
    (selectionChange)="onConsumedTypesChange($event)"
  ></app-media-types-grid>
  <p class="!mt-2 text-sm text-grey dark:text-lightGrey">
    {{ "ANIMATED_SERIES_SCOPE_HINT" | translate }}
  </p>
</div>

@if (!hidden) {
<div
  class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-5"
></div>

<div class="block mt-5 max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px]">
  <h2 class="mb-2">{{ "PROFILE_VISIBILITY" | translate }}</h2>
  <ul>
    @for (visibility of profileVisibilities; track trackByValue($index,
    visibility)) {
    <li
      class="mb-2"
      [ngClass]="{
        active: this.user.visibility === visibility
      }"
      (click)="updateProfileVisibility(visibility)"
      (keyup)="
        onKeyUp($event, 'updateProfileVisibility', undefined, visibility)
      "
      tabindex="-1"
    >
      <mat-radio-button
        class="white-border-radio cursor-pointer"
        [checked]="this.user.visibility === visibility"
        >{{ getProfileVisibilityLabel$(visibility) | async }}</mat-radio-button
      >
      <p class="!-mt-1 ml-5 text-sm text-grey dark:text-lightGrey">
        {{ "PROFILE_VISIBILITY_HINT_" + visibility | translate }}
      </p>
    </li>
    }
  </ul>
  <p class="!mt-2 text-sm text-grey dark:text-lightGrey">
    {{ "PROFILE_VISIBILITY_LISTS_HINT" | translate }}
  </p>
  <a
    routerLink="/recommendations/sent"
    [queryParams]="{filter: 'links'}"
    class="inline-block whitespace-nowrap text-sm underline"
    >{{ "WORK_SHARE.MANAGE_SHORT" | translate }}</a
  >
</div>
}

<div
  class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-2"
  [class]="hidden ? 'mt-2' : 'mt-5'"
></div>

<div
  [class]="
    'max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] ' +
    (hidden ? 'mt-2' : 'mt-5')
  "
>
  <h2 class="mb-1!">{{ "PUSH_NOTIFICATIONS" | translate }}</h2>
  <p class="italic mt-0 mb-2">{{ "PUSH_NOTIFICATIONS_TEXT" | translate }}</p>
  <mat-slide-toggle [(ngModel)]="isPushEnabled" (change)="togglePush($event)">
    {{ "ENABLE_PUSH_NOTIFICATIONS" | translate }}
  </mat-slide-toggle>
</div>

@if (!hidden) {
<div
  class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-5"
></div>

<div class="block mt-5 max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px]">
  <h2 class="mb-2">{{ "DASHBOARD_BLOCKS_HIDE" | translate }}</h2>
  <ul>
    @for (block of dashboardBlocks; track trackByBlock($index, block)) {
    <li
      class="inline mr-2"
      [ngClass]="{
        active: isSelected(block.key)
      }"
      (click)="hideDashboardBlock(block.key)"
      (keyup)="onKeyUp($event, 'hideDashboardBlock', block.key)"
      tabindex="-1"
    >
      <mat-checkbox
        class="white-border-checkbox"
        [checked]="isSelected(block.key)"
        >{{ block.label | translate }}</mat-checkbox
      >
    </li>
    }
  </ul>

  <div
    class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-5"
  ></div>

  <section class="mt-5">
    <h2 class="mb-1!">{{ "COMPASS_PROFILE_PLATFORMS_TITLE" | translate }}</h2>
    <div class="flex items-center justify-between mt-0 mb-5">
      <p class="m-0">
        {{ "COMPASS_PROFILE_PLATFORMS_SUBTITLE" | translate }}
      </p>
      <button
        type="button"
        class="underline shrink-0 ml-4"
        (click)="onPlatformConsoleKeysChange([])"
      >
        {{ "COMPASS_PLATFORM_CLEAR_ALL" | translate }}
      </button>
    </div>

    <app-platform-console-picker
      [selectedKeys]="platformConsoleKeys"
      [primaryKeys]="profilePlatformPrimaryKeys"
      buttonVariant="tablike"
      [showClearButton]="false"
      (selectedKeysChange)="onPlatformConsoleKeysChange($event)"
    ></app-platform-console-picker>
  </section>

  <div
    class="sep w-full max-w-[920px] xxl:max-w-[1120px] hd:max-w-[1310px] h-px bg-borders-light/10 mt-5"
  ></div>

  <app-edit-recommendations-preferences
    [user]="user"
    class="block my-8"
  ></app-edit-recommendations-preferences>
</div>
}
